import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  RoleStatus,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  NavSidebarWrapper,
  ProfileBannerWrapper,
  ProfileContainer,
  ProfileContent,
  ProfileWrapper,
  PropertiesStatusWrapper,
  SocialWrappper,
  UserProfileContentWrapper,
} from "../styled";
import { tabsArrayList } from "../TabsArray";
import { Link, useNavigate } from "react-router-dom";
import BannerImage from "../components/BannerImage";
import ProfileImageUpload from "../components/ProfileImageUpload";
import {
  inquiryListColumns,
  ProfileSidebarList,
  SocialProfile,
  specializationDropdownList,
} from "../../../../helpers/webConstants";
import {
  AvatarPlaceholder,
  BackArrow,
  Calendar,
  CalendarIcon,
  ClockIcon,
  Facebook,
  FalLogo,
  Globe,
  Instagram,
  Linkedin,
  Mosoq,
  One,
  Phone,
  ProfileImg,
  RightArrow,
  RightArrowShowProfile,
  Website,
  XSocial,
  Youtube,
} from "../../../../components/styled/AllImages";
import { UserProfileLogos } from "../../../../helpers/dummyConstants";
import { Col, Row } from "react-bootstrap";
import ServicesCities from "../../../../components/profile/ServicesCities";
import ProfileContact from "../../../../components/profile/contact/ProfileContact";
import LookingFor from "../../../../components/profile/lookingForBanner/LookingForBanner";
import { SmBanner } from "../../../../components/profile/lookingForBanner/styled";
import PopertiesListing from "../properties/popertiesListing";
import LeadFormMobile from "../../enquire/lead-form/LeadFormMobile";
import CustomTooltip from "../../../../components/common/dropdowns/CustomTooltip";
import ProfileSkeleton from "../../../../components/profile/PorfileSkeleton";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";
import LookingForListing from "../lookingForListing/LookingForListings";
import InquiryStatsBanner from "../../../../components/profile/inquiryStatsBanner/InquiryStatsBanner";
import ProfileApi from "../../../../services/api/profileApi";
import TableList from "../../../../components/common/table/TableList";
import { InquiryListStyled } from "./styled";
import InquiryModal from "../../../../components/auth/Modal/InquiryDetailsModal";
import { FaArrowLeftLong } from "react-icons/fa6";

import { resolveMediaUrl } from "../../../../utils/mediaUrl";

const InquiryList = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const sidebarRef = useRef();
  const [userProfile, setUserProfile] = useState({});
  const [inquiryList, setInquiryList] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [showAllLookingFor, setShowAllLookingFor] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [show, setShow] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth < 767);
  const [selectedInquiryId, setSelectedInquiryId] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [pagesInfo, setPagesInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth < 767);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleView = (row) => {
    setSelectedInquiryId(row);
    setShow(true);
  };

  const fetchUserProfile = async () => {
    try {
      setIsLoading(true);
      const response = await AuthApi.getAuthenticatedUser();

      if (response.code === 200) {
        setUserProfile(response.data);
        await fetchInquiryList(activePage);
      }
      if (response.code === 204) {
        setNotFound(true);
      }
      if (response.code === 100) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  const fetchInquiryList = async (page) => {
    try {
      const { data, code, message } = await ProfileApi.fetchInquiryList(page);
      if (code === 200 && data?.data) {
        setInquiryList(data?.data);
        setPagesInfo({
          perPage: data?.meta?.per_page,
          totalCount: data?.meta?.total,
        });
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchUserProfile();
  }, [language]);

  useEffect(() => {
    fetchInquiryList(activePage);
  }, [activePage, language]);

  return (
    <>
      {isLoading ? (
        <ProfileSkeleton />
      ) : notFound ? (
        <Box className="d-flex justify-content-center align-items-center h-50">
          <SpanStyled color="var(--text2)" size="30px">
            {t("profile_not_found")}
          </SpanStyled>
        </Box>
      ) : (
        <ProfileWrapper>
          <ProfileBannerWrapper>
            <BannerImage username={userProfile?.username} />
            <UserProfileContentWrapper>
              <Row>
                <Col md={12} lg={7} className="userProfileDetailView">
                  <Box className="userProfileAvatar">
                    <img
                      src={
                        userProfile?.profile
                          ? resolveMediaUrl(userProfile?.profile)
                          : AvatarPlaceholder
                      }
                      alt="Profile Image"
                      className="rounded-circle"
                    />
                  </Box>
                  <Box className="userProfileDetailAbout">
                    <HeadingStyled size="24px" weight={"bold"} lh="1">
                      {userProfile?.name}
                    </HeadingStyled>
                    <Box className="peopleMainRoleWrapper mt-3 mb-2">
                      <RoleStatus
                        status={
                          userProfile?.fal_information?.specialization
                            ? t(
                                specializationDropdownList?.find(
                                  (obj) =>
                                    obj.value ===
                                    parseInt(
                                      userProfile.fal_information.specialization
                                    )
                                )?.label || "N/A"
                              )
                            : "N/A"
                        }
                      />
                    </Box>
                    <Box className="userProfileAbout mb-2">
                      <SpanStyled
                        size="16px"
                        color="var(--darkGrey)"
                        weight={"bold"}
                      >
                        {userProfile?.personal_information?.about_me}
                      </SpanStyled>
                    </Box>
                    <Box className="userProfileLogos">
                      <CustomTooltip
                        data={{
                          title: t("fal_id"),
                          value: userProfile?.fal_information?.fal_number,
                        }}
                        image={FalLogo}
                      />
                      {userProfile?.fal_information?.mothoq_number && (
                        <CustomTooltip
                          data={{
                            title: t("wothoq_id"),
                            value: userProfile?.fal_information?.mothoq_number,
                          }}
                          image={Mosoq}
                        />
                      )}
                      {/* {UserProfileLogos.map((item, key) => (
                      <span className="userProfileLogo" key={key}>
                        {item.logo}
                      </span>
                    ))} */}
                    </Box>
                  </Box>
                </Col>
                <Col md={12} lg={5} className="socialPropStats">
                  <SocialWrappper>
                    {userProfile?.social_media?.website_url && (
                      <Link
                        to={userProfile?.social_media?.website_url}
                        target="_blank"
                        title={t("website")}
                      >
                        <Globe />
                      </Link>
                    )}
                    {userProfile?.social_media?.youtube_channel_link && (
                      <Link
                        to={userProfile?.social_media?.youtube_channel_link}
                        target="_blank"
                        title={t("youtube")}
                      >
                        <Youtube />
                      </Link>
                    )}
                    {userProfile?.social_media?.linkedin_profile_link && (
                      <Link
                        to={userProfile?.social_media?.linkedin_profile_link}
                        target="_blank"
                        title={t("linkedin")}
                      >
                        <Linkedin />
                      </Link>
                    )}
                    {userProfile?.social_media?.x_profile_link && (
                      <Link
                        to={userProfile?.social_media?.x_profile_link}
                        target="_blank"
                        title={t("x")}
                      >
                        <XSocial />
                      </Link>
                    )}
                    {userProfile?.social_media?.instagram_profile_link && (
                      <Link
                        to={userProfile?.social_media?.instagram_profile_link}
                        target="_blank"
                        title={t("instagram")}
                      >
                        <Instagram />
                      </Link>
                    )}
                    {userProfile?.social_media?.facebook_profile_link && (
                      <Link
                        to={userProfile?.social_media?.facebook_profile_link}
                        target="_blank"
                        title={t("facebook")}
                      >
                        <Facebook width={20} height={20} />
                      </Link>
                    )}
                    {userProfile?.social_media?.one_day_profile_link && (
                      <Link
                        to={userProfile?.social_media?.one_day_profile_link}
                        target="_blank"
                        title={t("one_day")}
                      >
                        <One width={22} height={22} />
                      </Link>
                    )}
                  </SocialWrappper>
                  <PropertiesStatusWrapper>
                    {userProfile?.personal_information?.years_of_experience && (
                      <Box className="propertiesStatusContainer">
                        <Box className="propertiesStatusBox">
                          <Box className="propertiesStatusExperience">
                            <SpanStyled family="var(--bold)" lh="1" size="12px">
                              {
                                userProfile?.personal_information
                                  ?.years_of_experience
                              }
                            </SpanStyled>
                          </Box>
                        </Box>
                        <Box className="propertiesStatusTitleNum">
                          <TextStyled size="14px" lh="1">
                            {t("YearsofExperience")}
                          </TextStyled>
                          <HeadingStyled
                            color="var(--themeColorSecondary)"
                            lh=".7"
                            size="24px"
                          >
                            {
                              userProfile?.personal_information
                                ?.years_of_experience
                            }
                          </HeadingStyled>
                        </Box>
                      </Box>
                    )}
                    {userProfile?.personal_information?.properties_sold && (
                      <Box className="propertiesStatusContainer">
                        <Box className="propertiesStatusBox px-2 text-center">
                          {t("Sold")}
                        </Box>
                        <Box className="propertiesStatusTitleNum">
                          <TextStyled size="14px" lh="1">
                            {t("PropertiesSold")}
                          </TextStyled>
                          <HeadingStyled
                            color="var(--themeColorSecondary)"
                            lh=".7"
                            size="24px"
                          >
                            {userProfile?.personal_information?.properties_sold}
                          </HeadingStyled>
                        </Box>
                      </Box>
                    )}
                  </PropertiesStatusWrapper>
                </Col>
              </Row>
            </UserProfileContentWrapper>
          </ProfileBannerWrapper>
          <InquiryListStyled className="mt-5 inquiry-list">
            <Box className="d-flex gap-2 align-items-center mb-3">
              <BackArrow
                onClick={() => navigate("/my-profile")}
                style={{
                  transform: language === "ar" ? "scale(-1)" : "scale(1)",
                }}
              />
              <HeadingStyled size="24px">{t("Inquiries")}</HeadingStyled>
            </Box>
            {isDesktop ? (
              <Row className="g-3">
                {inquiryList.map((item) => (
                  <Col xs={12} key={item.id}>
                    <Box
                      className="p-3 shadow-sm rounded-3 border inquiry-list-card"
                      style={{ background: "#fff", overflow: "hidden" }}
                    >
                      <Box className="d-flex justify-content-between align-items-start gap-2 mb-2 flex-wrap">
                        <Box style={{ minWidth: 0, flex: "1 1 auto" }}>
                          <HeadingStyled size="14px">
                            {item.full_name}
                          </HeadingStyled>
                          <TextStyled
                            size="12px"
                            color="#999"
                            className="gap-4"
                          >
                            <Box className="d-flex align-items-center gap-1 flex-wrap">
                              <CalendarIcon />
                              {new Date(item.created_at).toLocaleDateString(
                                "en-GB"
                              )}{" "}
                            </Box>
                            <Box className="d-flex align-items-center gap-1">
                              <ClockIcon />
                              {new Date(item.created_at).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </Box>
                          </TextStyled>
                        </Box>
                        <SpanStyled
                          className="px-3 py-1 rounded-5"
                          style={{
                            background: "#E9FDF2",
                            color: "#2EC28B",
                            fontSize: "12px",
                            flexShrink: 0,
                          }}
                        >
                          {item.inquiry_type}
                        </SpanStyled>
                      </Box>

                      <Box className="inquiry-card-actions mt-3">
                        <Box
                          className="inquiry-card-phone d-flex align-items-center justify-content-center gap-1 p-2 rounded-5"
                          bg="var(--bg)"
                        >
                          <Phone stroke="var(--text)" />
                          <SpanStyled size="16px">
                            {item.phone_number}
                          </SpanStyled>
                        </Box>
                        <ButtonStyled
                          label={t("viewInquiry")}
                          onClick={() => handleView(item.id)}
                          className="rounded-5 inquiry-view-btn"
                          clName="inquiry-view-btn-wrap"
                          bg="var(--white)"
                          iconWidth="14px"
                          border="var(--themeColorSecondary)"
                          color="var(--themeColorSecondary)"
                          iconColor="var(--themeColorSecondary)"
                          mirror={true}
                          iconAfter={RightArrowShowProfile}
                        />
                      </Box>
                    </Box>
                  </Col>
                ))}
              </Row>
            ) : (
              <TableList
                options={["more"]}
                idIndex={1}
                rows={inquiryList}
                columns={inquiryListColumns}
                onMore={handleView}
                activePage={activePage}
                setActivePage={setActivePage}
                totalCount={pagesInfo?.totalCount}
                perPage={pagesInfo?.perPage}
              />
            )}
          </InquiryListStyled>
          <InquiryModal
            show={show}
            onHide={() => setShow(false)}
            id={selectedInquiryId}
          />
        </ProfileWrapper>
      )}
    </>
  );
};

export default InquiryList;
